module.exports = {
  MESSAGE: 'message',
  RESPONSES: {
    SUCCESS: 'Y',
    NOERROR: 0
  },
  REQUESTS: {
    TRANSACTION_ACTION: {
      AUTHORIZATION: 'Authorization',
      SALE: 'Sale',
      ORDER: 'Order',
      REFUND: 'Refund'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./constants/messages.js
// module id = 69
// module chunks = 5